module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10276.4357ee7f.jpg";